import type { CSSProperties } from 'react';
import { cx } from '@/lib/cx';

export interface IconProps {
  /** A Material Symbols (Outlined) ligature name, e.g. `search`, `chevron_right`. */
  name: string;
  size?: number;
  filled?: boolean;
  className?: string;
  style?: CSSProperties;
  /** Give a label only when the icon carries meaning on its own; otherwise it is decorative. */
  label?: string;
}

export function Icon({ name, size = 20, filled, className, style, label }: IconProps) {
  return (
    <span
      className={cx('material-symbols-outlined', className)}
      style={{
        fontSize: size,
        lineHeight: 1,
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 400, 'opsz' 24`,
        userSelect: 'none',
        flex: 'none',
        ...style,
      }}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    >
      {name}
    </span>
  );
}
